module.exports = __webpack_public_path__ + "assets/img/xfe-layer-1-d1a22df8.png";